import React, { Component, ErrorInfo, ReactNode } from 'react';
import BugCatch, { bugCatchEnabled } from './bugcatch';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (bugCatchEnabled) {
            BugCatch.captureException(error, {
                componentStack: errorInfo.componentStack,
            });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="d-flex justify-content-center align-items-center flex-column vh-100">
                    <h2>Something went wrong.</h2>
                    <button className="btn btn-primary btn-lg mt-3" onClick={() => window.location.reload()}>
                        Reload page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
